import React, { useState } from "react";
import "./CustomerService.css";
import AffiliateBanners from "./AffiliateBanners";

const CustomerService = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="customer-service">
      <div className="container">
        
        {/* Hero Section */}
        <div className="hero-section">
          <h1>Kundservice</h1>
          <p>Vi finns här för att hjälpa dig med alla dina frågor om leksaksbilar och vårt samarbete med Leksaksbilar.se</p>
        </div>

        {/* Contact Section */}
        <div className="section">
          <h2>Kontakta Oss</h2>
          <div className="contact-grid">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <h3>Email</h3>
              <p>info@isaksbilar.se</p>
              <span>Svarstid: Inom 24 timmar på vardagar</span>
            </div>
            <div className="contact-card">
              <div className="contact-icon">🛒</div>
              <h3>Online Butik</h3>
              <p>Alltid tillgänglig</p>
              <span>24/7 tillgång till produkter</span>
            </div>
            <div className="contact-card">
              <div className="contact-icon">⚡</div>
              <h3>Snabbt Svar</h3>
              <p>Professionell service</p>
              <span>Vi svarar snabbt och hjälpsamt</span>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="section">
          <h2>Vanliga Frågor</h2>
          <div className="faq-container">
            <div className={`faq-item ${activeFaq === 0 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(0)}>
                <h3>Hur fungerar beställning?</h3>
                <span className="faq-toggle">+</span>
              </div>
              <div className="faq-answer">
                <p>Alla köp sker via Leksaksbilar.se. Klicka på 'Köp hos Leksaksbilar.se' för att gå till deras säkra betalningssida.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 1 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(1)}>
                <h3>Vilka betalningsmetoder accepteras?</h3>
                <span className="faq-toggle">+</span>
              </div>
              <div className="faq-answer">
                <p>Leksaksbilar.se accepterar alla vanliga betalningsmetoder inklusive Klarna, kortbetalning och faktura.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 2 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(2)}>
                <h3>Hur lång leveranstid?</h3>
                <span className="faq-toggle">+</span>
              </div>
              <div className="faq-answer">
                <p>Leveranstiden varierar beroende på produkt och lagerstatus. Vanligtvis 1-3 arbetsdagar.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 3 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(3)}>
                <h3>Kan jag returnera produkter?</h3>
                <span className="faq-toggle">+</span>
              </div>
              <div className="faq-answer">
                <p>Ja, du har 14 dagars ångerrätt enligt Leksaksbilar.se returpolicy.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 4 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(4)}>
                <h3>Är produkterna säkra för barn?</h3>
                <span className="faq-toggle">+</span>
              </div>
              <div className="faq-answer">
                <p>Alla produkter följer EU:s säkerhetsstandarder och är märkta med lämplig åldersrekommendation.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Affiliate Banner */}
        <AffiliateBanners type="medium" />

        {/* Product Information */}
        <div className="section">
          <h2>Våra Produkter</h2>
          <div className="product-info">
            <div className="product-highlights">
              <div className="highlight-item">
                <div className="highlight-icon">🚗</div>
                <h3>Över 4000 produkter</h3>
                <p>Från världens bästa märken</p>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🏆</div>
                <h3>Premium märken</h3>
                <p>Hot Wheels, LEGO, Siku, Majorette och många fler</p>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🎯</div>
                <h3>För alla åldrar</h3>
                <p>Från 1 år och uppåt</p>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">💰</div>
                <h3>Konkurrenskraftiga priser</h3>
                <p>Regelbundna erbjudanden</p>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🚚</div>
                <h3>Snabb leverans</h3>
                <p>Över hela Sverige</p>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🛡️</div>
                <h3>Full garanti</h3>
                <p>Säker betalning via Leksaksbilar.se</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CustomerService;
